import { Injectable, Injector, ApplicationRef, ComponentFactoryResolver } from '@angular/core';
import { SwDestructionService } from 'src/app/librarys/serves/sw-destruction.service';
import { SwMassageConfirmComponent } from './sw-massage-confirm.component';

@Injectable({
  providedIn: 'root'
})
export class SwMessageConfirmService {

  constructor(
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private SwDestructionService:SwDestructionService ///注入销毁组件的服务
  ) { }

  

  //确认消息框,有确认和取消按钮
  showConfirmModal(Title: string, headerLogo?: string, callback?:any){ 
    this.SwDestructionService.destruction("sw-massage-confirm");///销毁之前的组件
    const rootpop = document.createElement("sw-massage-confirm");
    const factory = this.componentFactoryResolver.resolveComponentFactory(SwMassageConfirmComponent);
    const componentRef = factory.create(this.injector, [], rootpop);
    this.applicationRef.attachView(componentRef.hostView);

    componentRef.instance.voted.subscribe((data)=>{
      if(data == true){
        if (callback){
          callback();
        }
      } 
      document.body.removeChild(rootpop);
      this.applicationRef.detachView(componentRef.hostView);
      componentRef.destroy()
    });
    componentRef.instance.Title = Title;
    componentRef.instance.headerLogo = headerLogo;
    componentRef.instance.createType = 2;
    document.body.appendChild(rootpop);
  }
}
